const ListType = 'list';
const ListItemType = 'list-item';
const listTypes = ['ordered', 'unordered'];
const listTypeHotkeyMap = {
  ordered: '7',
  unordered: '8'
};

export { ListItemType, ListType, listTypeHotkeyMap, listTypes };
